require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./every-b-2-b-saas-coding.json") })
        }
      }, "path---every-b-2-b-saas-coding");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---every-b-2-b-saas-coding!./.cache/json/every-b-2-b-saas-coding.json
// module id = 364
// module chunks = 231608221292675